module.exports = __webpack_public_path__ + "static/media/process.0ee57072.png";